module.exports = __webpack_public_path__ + "assets/48f30a2989cd35e2ccf4cf1c95c68e52.mp3";